var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22881 3.8212C3.07478 3.8212 3.76694 3.13861 3.76694 2.30434C3.76694 1.47008 3.07478 0.787491 2.22881 0.787491C1.38283 0.787491 0.690674 1.47008 0.690674 2.30434C0.690674 3.13861 1.38283 3.8212 2.22881 3.8212ZM2.22881 5.33805C1.38283 5.33805 0.690674 6.02064 0.690674 6.85491C0.690674 7.68918 1.38283 8.37176 2.22881 8.37176C3.07478 8.37176 3.76694 7.68918 3.76694 6.85491C3.76694 6.02064 3.07478 5.33805 2.22881 5.33805ZM2.22881 9.88862C1.38283 9.88862 0.690674 10.5712 0.690674 11.4055C0.690674 12.2397 1.38283 12.9223 2.22881 12.9223C3.07478 12.9223 3.76694 12.2397 3.76694 11.4055C3.76694 10.5712 3.07478 9.88862 2.22881 9.88862Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVert);
export default __webpack_public_path__ + "static/media/menu-vert.4b2066336edc9f0135874d525284664f.svg";
export { ForwardRef as ReactComponent };